import { Box, Stack, Typography } from "@mui/material";
import { Theme, useTheme } from "@mui/material/styles";
import dayjs from "dayjs";
import type { JSX } from "react";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import {
  ValuationHubCoreModelDtoValuationReportConfigurationDto,
  ValuationHubCoreModelRealEstateAddress,
} from "@/api/generatedApi";
import { InfoIcon } from "@/assets";
import { EnhancedTooltip } from "@/components/enhancedTooltip";
import { FormControlTextField } from "@/components/formControls";

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const createStyles = (theme: Theme) => ({
  containerGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
    columnGap: theme.analysisLayout.panelGap,
    rowGap: theme.analysisLayout.compactGap,
    width: "100%",
  },
  formInput: {
    backgroundColor: "white",
    width: "100%",
  },
  textFieldInput: {
    "& .MuiInputBase-root:not(.MuiInputBase-multiline)": {
      height: theme.analysisLayout.inputHeight,
    },
  },
});
interface TitleSectionProps {
  address: ValuationHubCoreModelRealEstateAddress | null;
}

export const TitleSection = ({ address }: TitleSectionProps): JSX.Element => {
  const theme = useTheme();
  const styles = createStyles(theme);
  const { t } = useTranslation("ValuationReportGenerationPanel");
  const { control } = useFormContext<ValuationHubCoreModelDtoValuationReportConfigurationDto>();
  const currentDate = dayjs().format("YYYY-MM-DD");
  const referenceNumberPlaceholder = `Bewertung_${address?.street}_${address?.house_number}_${address?.town}_${currentDate}`;

  return (
    <Box sx={styles.containerGrid}>
      <Stack alignItems={"start"} direction="column" spacing="10px">
        <Stack alignItems={"start"} direction="row">
          <Typography variant={"inputLabel"}>{t("reportPanel.configuration.title")}</Typography>
          <EnhancedTooltip content={t("reportPanel.configuration.titleTooltip")} placement="top">
            <Box>
              <InfoIcon sx={{ ml: 1, fontSize: theme.analysisLayout.titleFontSize, color: "primary.main" }} />
            </Box>
          </EnhancedTooltip>
        </Stack>
        <FormControlTextField
          name="title"
          control={control}
          sx={styles.formInput}
          textFieldSx={styles.textFieldInput}
          placeholder="Immobilienbewertung"
          inputProps={{ maxLength: 100 }}
          data-cy="report-configuration-title"
        />
      </Stack>
      <Stack alignItems={"start"} direction="column" spacing="10px">
        <Stack alignItems={"start"} direction="row">
          <Typography variant={"inputLabel"}>{t("reportPanel.configuration.referenceNumber")}</Typography>
          <EnhancedTooltip content={t("reportPanel.configuration.referenceNumberTooltip")} placement="top">
            <Box>
              <InfoIcon sx={{ ml: 1, fontSize: theme.analysisLayout.titleFontSize, color: "primary.main" }} />
            </Box>
          </EnhancedTooltip>
        </Stack>
        <FormControlTextField
          name="reference_number"
          control={control}
          sx={styles.formInput}
          textFieldSx={styles.textFieldInput}
          placeholder={referenceNumberPlaceholder}
          inputProps={{ maxLength: 100 }}
          data-cy="report-configuration-reference-number"
        />
      </Stack>
    </Box>
  );
};
